export enum BiFlagName {
  Timestamp = 'TIMESTAMP',
  Owner = 'OWNER',
  OwnerRole = 'OWNER_ROLE',
}
